// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const imgFlowModel = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/img-flow-model/img-flow-model.store.js